import { render, staticRenderFns } from "./Mail.List.vue?vue&type=template&id=0f138418&"
import script from "./Mail.List.vue?vue&type=script&lang=js&"
export * from "./Mail.List.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports